import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type ToggleOffProps = IconComponentBaseProps;

export const ToggleOff = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: ToggleOffProps) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <mask
        id="mask0_13364_72101"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_13364_72101)">
        <path
          d="M7 17.5C5.47217 17.5 4.17358 16.9655 3.10425 15.8965C2.03475 14.8275 1.5 13.5294 1.5 12.0023C1.5 10.4751 2.03475 9.17625 3.10425 8.10575C4.17358 7.03525 5.47217 6.5 7 6.5H17C18.5278 6.5 19.8264 7.0345 20.8958 8.1035C21.9653 9.1725 22.5 10.4706 22.5 11.9978C22.5 13.5249 21.9653 14.8237 20.8958 15.8942C19.8264 16.9648 18.5278 17.5 17 17.5H7ZM7 16H17C18.1 16 19.0417 15.6083 19.825 14.825C20.6083 14.0417 21 13.1 21 12C21 10.9 20.6083 9.95833 19.825 9.175C19.0417 8.39167 18.1 8 17 8H7C5.9 8 4.95833 8.39167 4.175 9.175C3.39167 9.95833 3 10.9 3 12C3 13.1 3.39167 14.0417 4.175 14.825C4.95833 15.6083 5.9 16 7 16ZM6.99875 14.75C7.76242 14.75 8.41183 14.4827 8.947 13.9482C9.48233 13.4137 9.75 12.7648 9.75 12.0012C9.75 11.2376 9.48275 10.5882 8.94825 10.053C8.41375 9.51767 7.76475 9.25 7.00125 9.25C6.23758 9.25 5.58817 9.51725 5.053 10.0518C4.51767 10.5863 4.25 11.2352 4.25 11.9988C4.25 12.7624 4.51725 13.4118 5.05175 13.947C5.58625 14.4823 6.23525 14.75 6.99875 14.75Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
